import {Link, Typography} from "@mui/material";
import {Box} from "@mui/system";
import {SUPPORT_EMAIL} from "../../../constants/common";

export default function PrivacyPolicy() {
    return (
        <Box className="ac-privacy-policy" p={4}>
        <Box p={{ xs: 2, md: 4}} mx="auto" className="ac-privacy-policy__content">
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                Open4feedback Privacy Policy
            </Typography>
        <br/>
        <br/>
            <Typography paragraph>
                This privacy policy describes how Open4feedback (“we”, “us”, “our”, “site”) collects,
                uses, shares, and secures the personal data of users of our website and/or services.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                WHAT INFORMATION DO WE COLLECT?
            </Typography>
            <Typography paragraph>
                We collect both personally identifiable information, and non-personally identifiable
                information from you. If you register as a teacher, we store the following information:
                your first and last name, your email address, the name of the school, your username,
                your encrypted password, and the pdf files of your presentations and videos (if you
                uploaded them). However, this information is also publicly available.  We use this
                information to verify if a person that is requesting a teacher’s account is a real teacher.
                Therefore, this information has to be public.  We also store your posts, such as questions,
                answers and discussions (Q/A/Ds) for every lecture.
            </Typography>

            <Typography paragraph>
                If you register as a student, we do not store any of your personally identifiable
                information. We store pseudonyms that we created and issued to you, your encrypted
                password and your posts (e.g. Q/A/Ds).
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                HOW DO WE USE YOUR INFORMATION?
            </Typography>
            <Typography paragraph>
                We use your information to allow you to login to our site and to interact
                with other users. For example, if you are a teacher, we use your information
                to allow you to create lectures, upload presentations, and to interact with
                students by posting questions, answers and joining discussions. If you are a
                student, we use your information to allow you to login to our site, and to
                make posts.
            </Typography>
            <Typography paragraph>
                We do not sell any of your information to third parties.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                WILL YOUR INFORMATION BE SHARED WITH ANYONE?
            </Typography>
            <Typography paragraph>
                We don’t share user information with advertisers, affiliates or partners. We
                also do not provide API access to our systems to third parties. We do not
                monetize our user traffic in any way. We use Amazon Web Services as our
                cloud hosting service provider.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            </Typography>
            <Typography paragraph>
                No, we don’t use cookies and other tracking technologies. Yes, not using
                cookies is possible.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?
            </Typography>
            <Typography paragraph>
                No, your information is not transferred internationally. Your information is
                kept on Amazon Web Servers located in the USA.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                HOW LONG DO WE KEEP YOUR INFORMATION?
            </Typography>
            <Typography paragraph>
                We keep your information as long as you are active. If you are not active for
                more than a year, we delete your account and all information associated with
                your account. If you would like to close your account, please email us at{" "}
                <Link  href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>

            <Typography fontWeight="bold" gutterBottom>
                HOW DO WE KEEP YOUR INFORMATION SAFE?
            </Typography>
            <Typography paragraph>
                We use industry standard practices to protect personal information from loss or theft, as
                well as unauthorized access, disclosure, copying, use or modification.  Your information
                is stored at AWS servers in the USA, and Amazon's data center operations have been
                accredited under ISO 27001 and SOC 1 and SOC 2.
            </Typography>

            <Typography fontWeight="bold" gutterBottom>
                WHAT ARE YOUR PRIVACY RIGHTS?
            </Typography>
            <Typography fontWeight="bold" >
                Right to access your data.
            </Typography>
            <Typography paragraph>
                You have the right to access your data (e.g. your email, username, etc.) at any time.
                You may request a copy of your data by email to{" "}
                <Link  href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>
            <Typography fontWeight="bold">
                Right to verify and seek rectification.
            </Typography>
            <Typography paragraph>
                You have the right to verify the accuracy of your data and update inaccurate or
                incomplete information about yourself which you can do either by managing your
                account through the Settings, or by contacting us at{" "}
                <Link href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>
            <Typography fontWeight="bold">
                Right to be informed.
            </Typography>
            <Typography paragraph>
                You have the right to be informed about
                how we process your information. We do this through this Privacy Policy,
                other information on our website, and by answering questions sent to us.
            </Typography>
            <Typography fontWeight="bold">
                Right to delete your personal data.
            </Typography>
            <Typography paragraph>
                You have the right request deletion of your personal data at any time by contacting us at{" "}
                <Link href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>
            <Typography fontWeight="bold">
                Right to restrict processing of your data.
            </Typography>
            <Typography paragraph>
                If you believe
                your information is incorrect, or you believe we use your data unlawfully or
                process your data unlawfully, you have the right to ask us to stop or limit
                the processing, which you request by email to{" "}
                <Link href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>

            <Typography fontWeight="bold" gutterBottom>
                DO WE MAKE UPDATES TO THIS POLICY?
            </Typography>
            <Typography paragraph>
                We may update this privacy policy from time to time. We will note the date on
                which the last revisions were made at the bottom of this privacy policy. Any
                revision will take effect upon publication on our website. Your access of the
                website and/or use of our services, after modification, addition or deletion
                of the privacy policy shall be deemed to constitute acceptance by you of the
                modification, addition or deletion.
            </Typography>

            <Typography  fontWeight="bold" gutterBottom>
                HOW CAN YOU CONTACT US ABOUT THIS POLICY?
            </Typography>
            <Typography paragraph>
                For any questions or concerns please contact{" "}
                <Link href={`mailto:${SUPPORT_EMAIL}`}>
                    {SUPPORT_EMAIL}
                </Link>.
            </Typography>

            <Typography mt={4} variant="body2">
                Last updated: September 9, 2025
            </Typography>
        </Box>
        </Box>
    );
}